<div class="transition-card">
  <div class="transition-card__card" [ngClass]="{'transition-card__card--reversed': isBackgroundReversed()}">
    <app-icon [svgIcon]="'long_lasting'" class="transition-card__icon"></app-icon>
    <div class="transition-card__description body-s">{{ description() }}</div>
  </div>
</div>
